import { useEffect, useState } from 'react'
import { createClient } from '@/lib/supabase/client'

export function useDynamicDocumentationContent(originalContent: string) {
  const [content, setContent] = useState(originalContent)
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  
  useEffect(() => {
    const checkAuth = async () => {
      const supabase = createClient()
      const { data: { user } } = await supabase.auth.getUser()
      setIsAuthenticated(!!user)
    }
    
    checkAuth()
  }, [])
  
  useEffect(() => {
    if (!originalContent) return
    
    let modifiedContent = originalContent
    
    if (isAuthenticated) {
      // Replace the login section for authenticated users
      const loginSectionRegex = /### How to Log In\n1\. Go to https:\/\/admin\.purpletree\.ie\n2\. Enter your email address\n3\. Enter your password\n4\. Click "Sign In"/g
      
      const authenticatedMessage = `### How to Log In\n\n😉 **You're already logged in!**\n\nYou can access all features of the system from the navigation menu on the left.`
      
      modifiedContent = modifiedContent.replace(loginSectionRegex, authenticatedMessage)
    }
    
    setContent(modifiedContent)
  }, [originalContent, isAuthenticated])
  
  return content
}